import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowUp } from '@yme/assets/icons';
import { Button, FADED_VARIANT, ICON_ONLY, SIZE_36 } from '@yme/atoms/button';
import { Link } from '@yme/components/Link';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { MAX_DROP_DOWN_ITEMS } from './constants';
import { DropDownControlStyled, SimpleDropDownStyled, UpButtonContainerMobileStyled, } from './styled';
export function NavListMobile({ title, pageLevelNavigationItems, upButton, trackNavigation, isDestinationPage, isRightToLeft, isClothingOrAccessoriesPDP, }) {
    const history = useHistory();
    const dropdownData = pageLevelNavigationItems.map((item) => ({
        label: item.title,
        value: item.link,
    }));
    const dropdownTitle = {
        label: title,
        value: '',
    };
    const selectOptionHandler = useCallback((option) => {
        history.push(option.value);
        trackNavigation(option.value)();
    }, [history, trackNavigation]);
    return (React.createElement(FlexWrapper, { gap: "8px" },
        upButton && !isDestinationPage && (React.createElement(UpButtonContainerMobileStyled, { isClothingOrAccessoriesPDP: isClothingOrAccessoriesPDP },
            React.createElement(Link, { to: upButton.link, onClick: trackNavigation(upButton.link, 'breadcrumb') },
                React.createElement(Button, { as: "span", hasIconButton: ICON_ONLY, buttonVariant: FADED_VARIANT, size: SIZE_36, iconComponent: ArrowUp })))),
        React.createElement(SimpleDropDownStyled, { selectedOption: dropdownTitle, setSelectedOption: selectOptionHandler, options: dropdownData, maxItemsVisible: MAX_DROP_DOWN_ITEMS, isRightToLeft: isRightToLeft, DropDownControlButton: DropDownControlStyled, color: colorCoreWhite1000, isArrowHidden: !dropdownData.length, isDestinationPage: isDestinationPage })));
}
